"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eight/sections/blogSliderEight.tsx */

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

type HomeEightBlogSliderEightBlogsItem = {
    /** Detected variants: "blog-img-one.jpg" | "blog-img-two.jpg" | "blog-img-three.jpg" */
    imageUrl: string;
    /** Detected variants: "Digital Eye Strain" | "Treatments" | "Wellness" */
    badge: string;
    /** Detected variants: "Computer Eye Strain: Causes, Symptoms" | "Expect Before & After Cataract Surgery" | "Daily Habits That Help Maintain Healthy Vision" */
    title: string;
    /** Detected variants: "Extended screen time reduces blinking, causes dryness, and strains..." | "Cataract surgery replaces the cloudy natural lens with an artificial..." | "Simple lifestyle changes like proper nutrition, screen breaks, and..." */
    description: string;
    /** Detected variants: "25, Nov 2026" | "28, Nov 2026" */
    date: string;
    /** Detected variants: "blog-img" */
    alt?: string;
};
export type HomeEightBlogSliderEightGeneratedProps = {
    blogs?: HomeEightBlogSliderEightBlogsItem[];
    divDiv0Button0ButtonVisible?: boolean;
    divDiv0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    divDiv0Button1ButtonVisible?: boolean;
    divDiv0Button1ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Button1ButtonProps?: Partial<ComponentProps<"button">>;
    divSwiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
};

const HomeEightBlogSliderEightGenerated: FC<HomeEightBlogSliderEightGeneratedProps> = ({
    blogs = [],
    divDiv0Button0ButtonVisible,
    divDiv0Button0ButtonRenderer,
    divDiv0Button0ButtonProps,
    divDiv0Button1ButtonVisible,
    divDiv0Button1ButtonRenderer,
    divDiv0Button1ButtonProps,
    divSwiper0SwiperProps,
}) => {
    return (
        <div className="blog-slide">
            <Swiper modules={[Navigation]} loop={true} speed={2000} slidesPerView={2} centeredSlides={false} navigation={{
                prevEl: ".blogs-prev",
                nextEl: ".blogs-next",
            }} breakpoints={{
                1400: { slidesPerView: 2 },
                1200: { slidesPerView: 2 },
                992: { slidesPerView: 2, centeredSlides: false },
                768: { slidesPerView: 1, centeredSlides: false }
            }} className="blog-slider-eight" {...(divSwiper0SwiperProps ?? {})}>
                {blogs.length < 2
                    ? [...blogs, ...blogs].map((blog, index) => (
                        <SwiperSlide key={index} className="slide-item">
                            <div className="blog-item-eight">
                                <div className="blog-overlay">
                                    <SmartImage
                                        src={blog.imageUrl}
                                        alt={blog.alt ?? "blog-img"}
                                        className="img-fluid"
                                    />
                                </div>
                                <div className="blog-content">
                                    <span className="badge">{blog.badge}</span>
                                    <h3 className="custom-title">
                                        <SmartLink href={"#"}>{blog.title}</SmartLink>
                                    </h3>
                                    <p className="description">{blog.description}</p>
                                    <div className="blog-icon">
                                        <i className="isax isax-calendar"></i>
                                        {blog.date}
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))
                    : blogs.map((blog, index) => (
                        <SwiperSlide key={index} className="slide-item">
                            <div className="blog-item-eight">
                                <div className="blog-overlay">
                                    <SmartImage
                                        src={blog.imageUrl}
                                        alt={blog.alt ?? "blog-img"}
                                        className="img-fluid"
                                    />
                                </div>
                                <div className="blog-content">
                                    <span className="badge">{blog.badge}</span>
                                    <h3 className="custom-title">
                                        <SmartLink href={"#"}>{blog.title}</SmartLink>
                                    </h3>
                                    <p className="description">{blog.description}</p>
                                    <div className="blog-icon">
                                        <i className="isax isax-calendar"></i>
                                        {blog.date}
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
            </Swiper>
            <div className="slide-btn">
                {renderNode(divDiv0Button0ButtonVisible, divDiv0Button0ButtonRenderer, (
                    <button type="button" className="slick-arrow blogs-prev" {...(divDiv0Button0ButtonProps ?? {})}>
                        <i className="isax isax-arrow-left-2"></i>
                    </button>
                ))}
                {renderNode(divDiv0Button1ButtonVisible, divDiv0Button1ButtonRenderer, (
                    <button type="button" className="slick-arrow blogs-next" {...(divDiv0Button1ButtonProps ?? {})}>
                        <i className="isax isax-arrow-right-3"></i>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default HomeEightBlogSliderEightGenerated;
